export default "__VITE_ASSET__DINbaf6M__"